import { useState, useEffect, useContext } from "react";
import { MasajidContext } from "../contexts/MasajidContext";
import Header from "./Header";
import Favourites from "./Favourites";
import BottomNavBar from "./BottomNavBar";

function FavouritesPage() {
  const { language } = useContext(MasajidContext);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <>
      <Header />

      <section className="section">
        {!isOnline && (
          <div style={{ marginTop: 64, textAlign: "center" }}>
            <h1
              style={{ color: "#f63c3c", marginTop: 64 }}
              lang={language === "urdu" && "ur"}
            >
              {language === "urdu"
                ? "آپ کا انٹرنیٹ کام نہیں کر رہا"
                : "Please connect to the internet"}
            </h1>
          </div>
        )}

        {isOnline && <Favourites />}
      </section>
      <BottomNavBar />
    </>
  );
}

export default FavouritesPage;
